import { render, staticRenderFns } from "./LocationManagement.vue?vue&type=template&id=59a7d60e&scoped=true"
import script from "./LocationManagement.ts?vue&type=script&lang=ts&external"
export * from "./LocationManagement.ts?vue&type=script&lang=ts&external"
import style0 from "./LocationManagement.scss?vue&type=style&index=0&id=59a7d60e&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a7d60e",
  null
  
)

export default component.exports